import React from "react";
import Link from "next/link";
import { CogIcon, InboxIcon, Newspaper, PlusIcon, SearchIcon } from "./icons";

const Nav: React.FC<{}> = (): React.ReactElement => {
  return (
    <nav className="flex items-center justify-between py-4">
      <div>
        <Link href="/inbox">
          <a className="text-gray-800 hover:text-gray-900 py-2 px-4 border-2 border-gray-800 hover:border-gray-900 rounded">
            Margins
          </a>
        </Link>
      </div>
      <div className="flex items-center">
        <Link href="/inbox">
          <a className="inline-block ml-1 fill-current text-gray-600 hover:text-gray-900 py-2 px-4 border border-gray-400 hover:border-gray-900 rounded">
            <InboxIcon className="h-4 w-4" />
          </a>
        </Link>
        <Link href="/references">
          <a className="inline-block ml-1 fill-current text-gray-600 hover:text-gray-900 py-2 px-4 border border-gray-400 hover:border-gray-900 rounded">
            <Newspaper className="h-4 w-4" />
          </a>
        </Link>
        <Link href="/new">
          <a className="inline-block ml-1 fill-current text-gray-600 hover:text-gray-900 py-2 px-4 border border-gray-400 hover:border-gray-900 rounded">
            <PlusIcon className="h-4 w-4" />
          </a>
        </Link>
        <Link href="/search">
          <a className="inline-block ml-1 fill-current text-gray-600 hover:text-gray-900 py-2 px-4 border border-gray-400 hover:border-gray-900 rounded">
            <SearchIcon className="h-4 w-4" />
          </a>
        </Link>
        <Link href="/settings">
          <a className="inline-block ml-1 fill-current text-gray-600 hover:text-gray-900 py-2 px-4 border border-gray-400 hover:border-gray-900 rounded">
            <CogIcon className="h-4 w-4" />
          </a>
        </Link>
      </div>
    </nav>
  );
};

export default Nav;
